import CircularProgressbarNewWithChildren from 'components/CircularProgressbar/CircularProgressbarSmallWithChildren';
import AddMultipleAssigneeDropdown from 'components/CustomDropdown/AddMultipleAssigneeDropdown';
import ComponentCircleLoader from 'components/Loaders/ComponentCircleLoader';
import StaticTaskLocationModal from 'custom_modules/TaskLocations/StaticTaskLocationModal';
import { t } from 'i18next';
import i18next from 'i18next';
import moment from 'moment';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { TaskStatus, TaskStatusButton } from 'styledComponents/tasks';
import { toHmins } from 'utils/helper';

import officeIcon from '../../../assets/img/Sidebar/offices-icon.svg';
import calendarIcon from '../../../assets/img/icons/Calendar.svg';
import documentIcon from '../../../assets/img/icons/Document.svg';
import assigneeIcon from '../../../assets/img/icons/assignee.svg';
import phoneIcon from '../../../assets/img/icons/phone.svg';
import tick from '../../../assets/img/icons/tick-white-bold.svg';
import userIcon from '../../../assets/img/icons/user.svg';
import userTagIcon from '../../../assets/img/icons/userTag.svg';
import statusIcon from '../../../assets/img/statusIcon.svg';
import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import { CardText } from '../../../components/DashboardCards/cardStyles';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import { ListUpperSection } from '../../../styledComponents/ProjectsNew';
import {
  PrimaryButton,
  TabButton,
  TabButtonContainer,
  WhiteButton,
} from '../../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContentHeader,
  InputLabel,
  PageTitle,
} from '../../../styledComponents/common';
import {
  CardBlock,
  GreenCircle,
  InfoSectionCard,
  LateTag,
} from '../../FieldServices/RouteMapNew/routeMapStyles';
import ChangeTimelineModal from '../ChangeTimelineModal';
import ApprovalSection from './approvalSection';
import Comment from './comment';
import {
  EmployeeEvidenceSection,
  FullWidthWithTopBorder,
  LabelTextBlock,
  StepCard,
  TaskDetailsInfoSection,
} from './taskDetailsStyles';
import TaskEvidence from './taskEvidence';

const TaskDetails = ({
  isLoading,
  taskDetailsLoading,
  selectedOrganization,
  orgMembersList,
  officesShortList,
  addTaskLocationLoading,
  getTaskDetails,
  taskDetails,
  editTask,
  callback,
  locationsList,
  createdTaskLocationInfo,
  memberShortListIsLoading,
  getOrganizationMembersList,
  getTaskType,
  createTask,
  getTaskLocation,
  addTaskLocation,
  getOfficesShortList,
  taskTypeIsLoading,
  taskTypeList,
  history,
  location,
  approvalMode,
  updateTaskApproval,
  selectedTab = 'submitted',
  updateTaskAssignee,
  removeTaskAssignee,
  updatePartialTask,
  getTaskHistory,
  taskHistory,
  reassignAssignee,
  reassignAssigneeLoading,
  reassignAssigneeInfo,
}) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [expandedSubTaskId, setExpandedSubTaskId] = useState(null);
  const [seeLocationModalOpen, setSeeLocationModalOpen] = useState(false);
  const [changeTimelineModalOpen, setChangeTimelineModalOpen] = useState(false);
  const [selectedTaskLocation, setSelectedTaskLocation] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState(null);
  const [secondStepEvidenceByUser, setSecondStepEvidenceByUser] = useState([]);
  const [tabSelect, setTabSelect] = useState('workTimeline');
  const [selectedReassignees, setSelectedReassignees] = useState([]);
  const [showReassignSave, setShowReassignSave] = useState(false);
  const [reassignableMembers, setReassignableMembers] = useState([]);
  const [firstStepMonazimEvidences, setFirstStepMonazimEvidences] = useState(
    [],
  );
  const [firstStepEvidence, setFirstStepEvidence] = useState([]);
  const [secondStepEvidence, setSecondStepEvidence] = useState([]);
  const [thirdStepEvidence, setThirdStepEvidence] = useState([]);
  const [firstStepRejectedEvidence, setFirstStepRejectedEvidence] = useState(
    [],
  );
  const [secondStepRejectedEvidence, setSecondStepRejectedEvidence] = useState(
    [],
  );
  const [thirdStepRejectedEvidence, setThirdStepRejectedEvidence] = useState(
    [],
  );

  const canUpdateSubTask =
    taskDetails?.approval_status === 'pending' &&
    selectedTab === 'submitted' &&
    (localStorage.getItem('user_role') !== 'employee' ||
      (taskDetails?.assignees &&
        taskDetails?.assignees.length > 0 &&
        taskDetails?.assignees[0].id === localStorage.getItem('user_id')));

  const popupToggle = index => {
    setPopupOpen(!popupOpen);
    setSelectedEvidence(index);
  };

  const updateDate = payload => {
    updatePartialTask({ ...payload, task_id: taskDetails.id });
  };

  const onTabSwitch = value => {
    setTabSelect(value);
  };

  const handleShowLocation = location => {
    setSelectedTaskLocation(location);

    setTimeout(() => {
      setSeeLocationModalOpen(true);
    }, 300);
  };

  const completedSubTasks = taskDetails?.sub_tasks?.filter(
    sub_task => sub_task.status === 'completed',
  ).length;
  const totalSubTasks = taskDetails?.sub_tasks?.length;
  const percentage =
    totalSubTasks > 0
      ? Math.ceil((completedSubTasks * 100) / totalSubTasks)
      : taskDetails?.status === 'completed'
      ? 100
      : 0;
  const lastCheckinout = taskDetails?.checkinout?.sort(
    (a, b) => b.checkin_timestamp - a.checkin_timestamp,
  )[0];

  const updateTaskStatusRequest = data => {
    const payload = { task_id: taskDetails?.id, data };
    updateTaskApproval(payload);
  };
  useEffect(() => {
    if (!approvalMode) {
      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        setTaskId(queryParsed.id);
        getTaskDetails({ task_id: queryParsed.id });
        getTaskHistory({ task_id: queryParsed.id });
      }
      getOrganizationMembersList({
        label: 'all',
      });
      getTaskType();
    }
    if (approvalMode && taskDetails?.approval_status === 'rejected') {
      getOrganizationMembersList({
        label: 'all',
      });
    }
    // return () => {
    //   setTaskId(null);
    //   setFirstStepEvidence([]);
    //   setSecondStepEvidence([]);
    //   setThirdStepEvidence([]);
    //   setFirstStepRejectedEvidence([]);
    //   setSecondStepRejectedEvidence([]);
    //   setThirdStepRejectedEvidence([]);
    //   setFirstStepMonazimEvidences([]);
    //   setSelectedAssignee(null);
    //   setSelectedReassignees([]);
    //   setReassignableMembers([]);
    //   setShowReassignSave(false);
    //   setPreviousReassignAssigneeLoading(false);
    // };
  }, []);

  useEffect(() => {
    if (taskDetails?.assignees.length > 0) {
      const assignee = taskDetails?.evidences.find(
        evidence => evidence?.submitted_by_user?.name,
      );
      setSelectedAssignee(assignee?.submitted_by_user);
      if (
        taskDetails?.monazim_rejection_evidences?.length > 0 &&
        taskDetails?.monazim_rejection_evidences[0]?.evidence_cycle
      ) {
        let tempSecondStepEvidenceByUser = [];
        tempSecondStepEvidenceByUser.push(
          taskDetails?.monazim_rejection_evidences[0]?.evidence_cycle,
        );
        setSecondStepEvidenceByUser(tempSecondStepEvidenceByUser);
      }
    }
    if (Array.isArray(taskDetails?.monazimevidences)) {
      setFirstStepMonazimEvidences(taskDetails?.monazimevidences);
    }
    if (Array.isArray(taskDetails?.evidences) && !approvalMode) {
      const evidences1stStep = [];
      const evidences2ndStep = [];
      const evidences3rdStep = [];

      Array.isArray(taskDetails?.evidences)
        ? taskDetails.evidences.map(evidence => {
            if (evidence?.evidence_cycle === null) {
              evidences1stStep.push(evidence);
            }
            if (
              evidence?.evidence_cycle &&
              evidence?.evidence_cycle?.cycle_number === 2
            ) {
              evidences2ndStep.push(evidence);
            }
            if (
              evidence?.evidence_cycle &&
              evidence?.evidence_cycle?.cycle_number === 3
            ) {
              evidences3rdStep.push(evidence);
            }
          })
        : [];
      setFirstStepEvidence(evidences1stStep);
      setSecondStepEvidence(evidences2ndStep);
      setThirdStepEvidence(evidences3rdStep);
    }
    if (
      Array.isArray(taskDetails?.monazim_rejection_evidences) &&
      !approvalMode
    ) {
      const rejectedEvidences1stStep = [];
      const rejectedEvidences2ndStep = [];
      const rejectedEvidences3rdStep = [];

      taskDetails?.monazim_rejection_evidences.map(evidence => {
        if (evidence?.evidence_cycle === null) {
          rejectedEvidences1stStep.push(evidence);
        }
        if (
          evidence?.evidence_cycle &&
          evidence?.evidence_cycle?.cycle_number === 2
        ) {
          rejectedEvidences2ndStep.push(evidence);
        }
        if (
          evidence?.evidence_cycle &&
          evidence?.evidence_cycle?.cycle_number === 3
        ) {
          rejectedEvidences3rdStep.push(evidence);
        }
      });
      setFirstStepRejectedEvidence(rejectedEvidences1stStep);
      setSecondStepRejectedEvidence(rejectedEvidences2ndStep);
      setThirdStepRejectedEvidence(rejectedEvidences3rdStep);
    }
    if (approvalMode) {
      const evidences1stStep = [];
      const evidences2ndStep = [];
      const evidences3rdStep = [];

      const rejectedEvidences1stStep = [];
      const rejectedEvidences2ndStep = [];
      const rejectedEvidences3rdStep = [];

      taskDetails?.evidences.map(evidence => {
        if (evidence?.evidence_cycle === null) {
          if (evidence?.is_rejection_evidence === false) {
            evidences1stStep.push(evidence);
          } else {
            rejectedEvidences1stStep.push(evidence);
          }
        }
        if (
          evidence?.evidence_cycle &&
          evidence?.evidence_cycle?.cycle_number === 2
        ) {
          if (evidence?.is_rejection_evidence === false) {
            evidences2ndStep.push(evidence);
          } else {
            rejectedEvidences2ndStep.push(evidence);
          }
        }
        if (
          evidence?.evidence_cycle &&
          evidence?.evidence_cycle?.cycle_number === 3
        ) {
          if (evidence?.is_rejection_evidence === false) {
            evidences3rdStep.push(evidence);
          } else {
            rejectedEvidences3rdStep.push(evidence);
          }
        }
      });
      setFirstStepEvidence(evidences1stStep);
      setSecondStepEvidence(evidences2ndStep);
      setThirdStepEvidence(evidences3rdStep);
      setFirstStepRejectedEvidence(rejectedEvidences1stStep);
      setSecondStepRejectedEvidence(rejectedEvidences2ndStep);
      setThirdStepRejectedEvidence(rejectedEvidences3rdStep);
    }
  }, [taskDetails]);

  // useEffect(() => {
  //   if (orgMembersList?.length > 0) {
  //     let members = [];
  //     orgMembersList.map((member) => {
  //       if (
  //         member.role === "employee" ||
  //         (member.office_id === taskDetails.office.id &&
  //           member.role === "gm") ||
  //         (member.office_id === taskDetails.office.id &&
  //           member.role === "agm" &&
  //           member.region === taskDetails?.region)
  //       ) {
  //         members.push(member);
  //       }
  //     });
  //     setReassignableMembers(members);
  //   }
  // }, [orgMembersList]);

  useEffect(() => {
    if (orgMembersList?.length > 0 && taskDetails) {
      const members = orgMembersList.filter(member => {
        if (member.role === 'employee') {
          return true;
        }

        if (
          member.role === 'gm' &&
          taskDetails.office &&
          member.office_id === taskDetails.office.id
        ) {
          return true;
        }

        if (
          member.role === 'agm' &&
          taskDetails.office &&
          member.office_id === taskDetails.office.id &&
          member.region === taskDetails.region
        ) {
          return true;
        }

        return false;
      });
      setReassignableMembers(members);
    }
  }, [orgMembersList, taskDetails]);

  useEffect(() => {
    if (reassignAssigneeInfo) {
      setShowReassignSave(false);
    }
  }, [reassignAssigneeInfo]);

  useEffect(() => {
    if (previousReassignAssigneeLoading && !reassignAssigneeLoading) {
      if (taskDetails && taskDetails.id) {
        setShowReassignSave(false);
        window.location.reload();
      }
    }
    setPreviousReassignAssigneeLoading(reassignAssigneeLoading);
  }, [reassignAssigneeLoading]);

  const [previousReassignAssigneeLoading, setPreviousReassignAssigneeLoading] =
    useState(false);

  const handleReassign = () => {
    if (selectedReassignees.length > 0 && reassignAssigneeLoading === false) {
      const assigneeIds = selectedReassignees.map(assignee => assignee.id);
      // if(approvalMode && taskDetails?.approval_status === 'rejected'){
      //   updateTaskApproval({
      //     task_id: taskDetails.id,
      //     data: {
      //       approval_status: 'pending',
      //     },
      //   });
      // }
      reassignAssignee({
        task_id: taskDetails.id,
        new_assignees: assigneeIds,
      });
    }
  };

  const handleAssignOrRemoveMember = (user, action) => {
    if (user && user.id) {
      let newArr = [...selectedReassignees];
      if (action === 'remove') {
        newArr = newArr.filter(member => member.id !== user.id);
      } else {
        newArr.push(user);
      }
      setSelectedReassignees(newArr);
      setShowReassignSave(true);
    }
  };

  const handleAssignMember = user => {
    handleAssignOrRemoveMember(user, 'assign');
  };

  const handleRemoveMember = user => {
    handleAssignOrRemoveMember(user, 'remove');
  };

  return (
    <div className="content">
      <StaticTaskLocationModal
        isOpen={seeLocationModalOpen}
        toggle={() => {
          setSeeLocationModalOpen(false);
          setSelectedTaskLocation(null);
        }}
        taskLocation={selectedTaskLocation}
      />
      {/* {!approvalMode && (
        <ChangeTimelineModal
          isOpen={changeTimelineModalOpen}
          toggle={() => setChangeTimelineModalOpen(!changeTimelineModalOpen)}
          updateDate={updateDate}
        />
      )} */}
      {!approvalMode && (
        <>
          <PageTitle>{t('ticket_details')}</PageTitle>
          <ContentHeader>
            <BackButtonComponent
              onClick={() => history.push('/user/tickets')}
              subTitle={t('back_to_all_tickets')}
            />
          </ContentHeader>
        </>
      )}
      {taskDetailsLoading ? (
        <ComponentCircleLoader />
      ) : (
        <Container padding="30px" gap="25px">
          <ListUpperSection style={{ gridTemplateColumns: `1fr auto` }}>
            <CommonText name title fontSize="16px">
              {taskDetails?.name}
            </CommonText>
          </ListUpperSection>
          <TaskDetailsInfoSection>
            <TaskDetailsSingleInfo
              icon={statusIcon}
              title="ticket_no"
              value={
                <CommonFlex>
                  <CommonText>{taskDetails?.task_code}</CommonText>
                  <TaskStatus
                    status={taskDetails?.status ? taskDetails?.status : 'new'}
                  >
                    {i18next.language && i18next.language === 'en'
                      ? t(taskDetails?.status).toUpperCase()
                      : t(taskDetails?.status)}
                  </TaskStatus>
                  <TaskStatus status={taskDetails?.approval_status}>
                    {t(taskDetails?.approval_status)}
                  </TaskStatus>
                </CommonFlex>
              }
            />{' '}
            <TaskDetailsSingleInfo
              icon={phoneIcon}
              title="phone"
              value={<CommonText>{taskDetails?.created_by?.phone}</CommonText>}
            />
            <div>
              <TaskDetailsSingleInfo
                icon={assigneeIcon}
                title="assignee"
                value={
                  localStorage.getItem('user_role') === 'admin' && (
                    <AddMultipleAssigneeDropdown
                      numberOfVisibleMembers={8}
                      isLoading={false}
                      hasPermission={false}
                      assigneesList={taskDetails?.assignees?.map(assignee => {
                        return {
                          ...assignee,
                          name:
                            `${assignee.first_name} ${assignee.last_name}`.trim() ||
                            assignee.first_name,
                        };
                      })}
                      membersList={orgMembersList?.filter(
                        member =>
                          member.role !== 'monazim' && member.role !== 'admin',
                      )}
                      handleAssign={() => {}}
                      handleRemove={() => {}}
                    />
                  )
                }
              />
              {(taskDetails?.status === 'assigned' ||
                taskDetails?.approval_status === 'rejected') && (
                <CommonGrid
                  columns="180px auto auto"
                  justifyContent="start"
                  columnGap="200px"
                  margin="15px 0 0 0"
                >
                  {/* <CommonText >{t(['re_assign'])}</CommonText> */}

                  <TaskDetailsSingleInfo
                    icon={assigneeIcon}
                    title={t(['re_assign'])}
                  />
                  <AddMultipleAssigneeDropdown
                    numberOfVisibleMembers={8}
                    isLoading={memberShortListIsLoading}
                    assigneesList={selectedReassignees}
                    membersList={reassignableMembers}
                    hasPermission={
                      localStorage.getItem('user_role') === 'admin' &&
                      (taskDetails?.status === 'assigned' ||
                        taskDetails?.approval_status === 'rejected')
                    }
                    handleAssign={handleAssignMember}
                    handleRemove={handleRemoveMember}
                  />
                  {showReassignSave && (
                    <PrimaryButton
                      height="36px"
                      margin="0 auto 0 0"
                      onClick={() => handleReassign()}
                    >
                      {reassignAssigneeLoading ? (
                        <ButtonTextLoader
                          loadingText="Saving"
                          fontSize="13px"
                        />
                      ) : (
                        'Save'
                      )}
                    </PrimaryButton>
                  )}
                </CommonGrid>
              )}
            </div>
            {/* <TaskDetailsSingleInfo
              icon={calendarIcon}
              title="timeline"
              onClick={() =>
                taskDetails?.status !== 'partial' &&
                taskDetails?.status !== 'completed' &&
                taskDetails?.status !== 'cancelled' &&
                setChangeTimelineModalOpen(true)
              }
              value={
                <CommonText>
                  {moment(taskDetails?.required_start_date).format(
                    'D MMM, h:mm A',
                  ) +
                    ' - ' +
                    moment(taskDetails?.required_end_date).format(
                      'D MMM, h:mm A',
                    )}
                </CommonText>
              }
            /> */}
            <TaskDetailsSingleInfo
              icon={officeIcon}
              title="office"
              value={<CommonText>{taskDetails?.office?.name}</CommonText>}
            />
            <TaskDetailsSingleInfo
              icon={userTagIcon}
              title="monazim_code"
              value={
                <CommonText>{taskDetails?.created_by?.monazim_code}</CommonText>
              }
            />
            <TaskDetailsSingleInfo
              icon={userIcon}
              title="monazim"
              value={
                <CommonText>
                  {' '}
                  {taskDetails?.created_by?.first_name}{' '}
                  {taskDetails?.created_by?.last_name}
                </CommonText>
              }
            />
            <TaskDetailsSingleInfo
              icon={officeIcon}
              title="created_at"
              value={
                <CommonText>
                  {moment(taskDetails?.created_at).format('D MMM, h:mm A')}
                </CommonText>
              }
            />
            <TaskDetailsSingleInfo
              icon={officeIcon}
              title="region"
              value={<CommonText>{taskDetails?.region}</CommonText>}
            />
          </TaskDetailsInfoSection>{' '}
          <TaskDetailsSingleInfo
            icon={documentIcon}
            title="description"
            value={<CommonText>{taskDetails?.description}</CommonText>}
          />
          <TaskDetailsSingleInfo
            icon={documentIcon}
            title="solved_by"
            value={
              <CommonText>
                {
                  taskDetails?.checkinout[taskDetails?.checkinout.length - 1]
                    ?.user?.name
                }
              </CommonText>
            }
          />
          <InfoSectionCard style={{ maxWidth: `530px` }}>
            {/* <CardBlock>
              <CardText name fontSize="13px" title nowrap>
                {taskDetails?.required_start_date &&
                taskDetails?.required_end_date
                  ? toHmins(
                      moment
                        .duration(
                          moment(taskDetails?.required_end_date).diff(
                            moment(taskDetails?.required_start_date),
                          ),
                        )
                        .asSeconds(),
                    )
                  : '-'}
              </CardText>
              <CardText fontSize="12px" label title>
                {t('ticket_duration')}
              </CardText>
            </CardBlock>{' '} */}
            <CardBlock>
              <CardText name fontSize="13px" title nowrap>
                {lastCheckinout?.checkin_timestamp ? (
                  <>
                    {moment
                      .unix(lastCheckinout.checkin_timestamp)
                      .format('h:mm a')}
                    {moment
                      .unix(lastCheckinout.checkin_timestamp)
                      .isAfter(moment(taskDetails?.required_start_date)) ? (
                      <LateTag>{t('late')}</LateTag>
                    ) : (
                      <GreenCircle>
                        <img src={tick} alt="" width="100%" />
                      </GreenCircle>
                    )}
                  </>
                ) : (
                  `-`
                )}
              </CardText>
              <CardText fontSize="12px" label title>
                {t('checked_in')}
              </CardText>
            </CardBlock>
            <CardBlock>
              <CardText name fontSize="13px" title nowrap>
                {lastCheckinout?.checkout_timestamp ? (
                  <>
                    {moment
                      .unix(lastCheckinout.checkout_timestamp)
                      .format('h:mm a')}
                    {moment
                      .unix(lastCheckinout.checkout_timestamp)
                      .isAfter(moment(taskDetails?.required_end_date)) ? (
                      <LateTag>{t('late')}</LateTag>
                    ) : (
                      <GreenCircle>
                        <img src={tick} alt="" width="100%" />
                      </GreenCircle>
                    )}
                  </>
                ) : (
                  `-`
                )}
              </CardText>
              <CardText fontSize="12px" label title>
                {t('checked_out')}
              </CardText>
            </CardBlock>
            <CardBlock>
              <CardText name fontSize="13px" title nowrap>
                {lastCheckinout?.checkin_timestamp
                  ? toHmins(
                      (lastCheckinout?.checkout_timestamp
                        ? lastCheckinout?.checkout_timestamp
                        : moment().unix()) - lastCheckinout?.checkin_timestamp,
                    )
                  : `-`}
              </CardText>
              <CardText fontSize="12px" label title>
                {t('worked')}
              </CardText>
            </CardBlock>
          </InfoSectionCard>
          <TabButtonContainer columns="auto auto" margin="0 auto 0 0">
            <TabButton
              onClick={() => onTabSwitch('workTimeline')}
              selected={tabSelect}
              index={'workTimeline'}
            >
              {t('work_timeline')}
            </TabButton>
            <TabButton
              onClick={() => onTabSwitch('location')}
              selected={tabSelect}
              index={'location'}
            >
              {t('the_site')}
            </TabButton>
          </TabButtonContainer>
          {/* <LabelTextBlock style={{ marginTop: `10px` }}>
              <InputLabel>{t('location_address')}:</InputLabel>
              <CommonText name>{taskDetails?.location?.name}</CommonText>
            </LabelTextBlock> */}
          {tabSelect === 'workTimeline' && (
            <>
              <CommonGrid columns="auto 1fr">
                <div
                  style={{
                    width: `1px`,
                    height: `100%`,
                    backgroundColor: `#E0E0E0`,
                  }}
                />
                <div>
                  <StepCard>
                    <div>
                      <CommonText name title fontSize="14px">
                        {t('1st_step')}
                      </CommonText>
                      <CommonText name fontSize="13px">
                        {moment(taskDetails?.created_at).format(
                          'D MMM YYYY, h:mm A',
                        )}
                      </CommonText>
                    </div>
                    <div>
                      <CommonText name title fontSize="14px">
                        {`${taskDetails?.created_by?.first_name} ${taskDetails?.created_by?.last_name}`}
                      </CommonText>
                      <CommonText name fontSize="14px">
                        Monazim
                      </CommonText>
                      {firstStepMonazimEvidences?.length > 0 && (
                        <TaskEvidence
                          evidences={firstStepMonazimEvidences.filter(
                            evidence => evidence?.evidence_cycle === null,
                          )}
                          noTitle
                        />
                      )}
                      <EmployeeEvidenceSection>
                        {selectedAssignee && (
                          <CommonText name title fontSize="14px">
                            {selectedAssignee.name}
                          </CommonText>
                        )}
                        <CommonText name fontSize="14px">
                          Employee
                        </CommonText>
                        {firstStepEvidence?.length > 0 && (
                          <TaskEvidence evidences={firstStepEvidence} noTitle />
                        )}
                      </EmployeeEvidenceSection>
                      {firstStepRejectedEvidence?.length > 0 && (
                        <EmployeeEvidenceSection>
                          <CommonFlex>
                            <TaskStatus
                              status={
                                !firstStepRejectedEvidence[0]?.is_approved
                                  ? 'rejected'
                                  : ''
                              }
                            >
                              {t(
                                firstStepRejectedEvidence[0]?.is_approved
                                  ? 'approved'
                                  : 'rejected',
                              )}
                            </TaskStatus>
                            <CommonText name title fontSize="14px">
                              {`by ${firstStepRejectedEvidence[0]?.submitted_by_user?.name}`}
                            </CommonText>
                          </CommonFlex>
                          <div style={{ marginTop: '10px' }}>
                            {firstStepRejectedEvidence?.length > 0 && (
                            <TaskEvidence
                              evidences={firstStepRejectedEvidence}
                                noTitle
                              />
                            )}
                          </div>
                        </EmployeeEvidenceSection>
                      )}
                    </div>
                  </StepCard>

                  {secondStepEvidence?.length > 0 && (
                    <StepCard>
                      <div>
                        <CommonText name title fontSize="14px">
                          {t('2nd_step')}
                        </CommonText>
                      </div>
                      <div>
                        <CommonText name title fontSize="14px">
                          {secondStepEvidence[0]?.submitted_by_user?.name}
                        </CommonText>
                        <CommonText name fontSize="14px">
                          Employee
                        </CommonText>
                        <TaskEvidence evidences={secondStepEvidence} noTitle />
                        {secondStepRejectedEvidence?.length > 0 && (
                          <EmployeeEvidenceSection>
                            <CommonFlex>
                              <TaskStatus
                                status={
                                  !secondStepRejectedEvidence[0]?.is_approved
                                    ? 'rejected'
                                    : ''
                                }
                              >
                                {t(
                                  secondStepRejectedEvidence[0]?.is_approved
                                    ? 'approved'
                                    : 'rejected',
                                )}
                              </TaskStatus>
                              <CommonText name title fontSize="14px">
                                {`by ${secondStepRejectedEvidence[0]?.submitted_by_user?.name}`}
                              </CommonText>
                            </CommonFlex>
                            <div style={{ marginTop: '10px' }}>
                              {secondStepRejectedEvidence?.length > 0 && (
                                <TaskEvidence
                                  evidences={secondStepRejectedEvidence}
                                  noTitle
                                />
                              )}
                            </div>
                          </EmployeeEvidenceSection>
                        )}
                      </div>
                    </StepCard>
                  )}

                  {thirdStepEvidence?.length > 0 && (
                    <StepCard>
                      <div>
                        <CommonText name title fontSize="14px">
                          {t('3rd_step')}
                        </CommonText>
                      </div>
                      <div>
                        <CommonText name title fontSize="14px">
                          {thirdStepEvidence[0]?.submitted_by_user?.name}
                        </CommonText>
                        <CommonText name fontSize="14px">
                          Employee
                        </CommonText>
                        <TaskEvidence evidences={thirdStepEvidence} noTitle />
                        {thirdStepRejectedEvidence?.length > 0 && (
                          <EmployeeEvidenceSection>
                            <CommonFlex>
                              <TaskStatus
                                status={
                                  !thirdStepRejectedEvidence[0]?.is_approved
                                    ? 'rejected'
                                    : ''
                                }
                              >
                                {t(
                                  thirdStepRejectedEvidence[0]?.is_approved
                                    ? 'approved'
                                    : 'rejected',
                                )}
                              </TaskStatus>
                              <CommonText name title fontSize="14px">
                                {`by ${thirdStepRejectedEvidence[0]?.submitted_by_user?.name}`}
                              </CommonText>
                            </CommonFlex>
                            <div style={{ marginTop: '10px' }}>
                              {thirdStepRejectedEvidence?.length > 0 && (
                                  <TaskEvidence
                                    evidences={thirdStepRejectedEvidence}
                                    noTitle
                                  />
                                )}
                            </div>
                          </EmployeeEvidenceSection>
                        )}
                      </div>
                    </StepCard>
                  )}
                </div>
              </CommonGrid>
            </>
          )}
          {taskDetails?.location && tabSelect === 'location' && (
            <ColoredText
              type="warning"
              hover
              onClick={() => handleShowLocation(taskDetails?.location)}
              fontSize="14px"
              style={{ cursor: 'pointer' }}
            >
              {t('see_location')}
            </ColoredText>
          )}
          <FullWidthWithTopBorder>
            <CommonText name title fontSize="16px">
              {t('comments')}
            </CommonText>
            <Comment
              type="employee_note"
              comment={taskDetails?.employee_note}
            />
            <Comment
              type="supervisor_note"
              comment={taskDetails?.supervisor_note}
            />
          </FullWidthWithTopBorder>
          {
            // taskDetails?.status === 'completed' &&
            approvalMode &&
              taskDetails?.approval_status === 'pending' &&
              (localStorage.getItem('user_role') === 'monazim' ||
                localStorage.getItem('user_role') === 'sub-monazim') &&
              selectedTab === 'submitted' &&
              taskDetails?.assignees &&
              taskDetails?.assignees.length > 0 &&
              taskDetails?.assignees[0].id !==
                localStorage.getItem('user_id') && (
                <FullWidthWithTopBorder max={'auto'}>
                  <CommonGrid columns={'3fr 1fr'}>
                    <ApprovalSection
                      task_id={taskDetails?.id}
                      history={history}
                      updateTaskStatusRequest={updateTaskStatusRequest}
                      percentage={percentage}
                      submitted={true}
                    />
                  </CommonGrid>
                </FullWidthWithTopBorder>
              )
          }
          {approvalMode &&
            taskDetails?.approval_status === 'rejected' &&
            localStorage.getItem('user_role') === 'admin' &&
            selectedTab === 'rejected' &&
            taskDetails?.assignees &&
            taskDetails?.assignees.length > 0 &&
            taskDetails?.assignees[0].id !==
              localStorage.getItem('user_id') && (
              <FullWidthWithTopBorder max={'auto'}>
                <CommonGrid columns={'3fr 1fr'}>
                  <ApprovalSection
                    task_id={taskDetails?.id}
                    history={history}
                    updateTaskStatusRequest={updateTaskStatusRequest}
                    percentage={percentage}
                    submitted={false}
                  />
                </CommonGrid>
              </FullWidthWithTopBorder>
            )}
          {}
        </Container>
      )}
    </div>
  );
};

export default TaskDetails;

const TaskDetailsSingleInfo = ({ icon, title, value, onClick }) => {
  return (
    <CommonGrid columns="180px 1fr">
      <CommonGrid columns="15px 1fr" alignItem="center">
        <img src={icon} alt="" style={{ height: '16px', width: '16px' }} />
        <CommonText> {t(title)}</CommonText>
      </CommonGrid>
      <CommonFlex
        onClick={() => {
          onClick && onClick();
        }}
      >
        {value}
      </CommonFlex>
    </CommonGrid>
  );
};
